// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1bj9M","selected":"Chip_selected__28Y1R"};